const awsRoot = "https://guugcall-prod.s3-sa-east-1.amazonaws.com/";

export default awsRoot;
